import {
  ROUTE_SECTION_EAT_FRESH,
  ROUTE_SECTION_STAY_ACTIVE,
  ROUTE_SECTION_BE_PRODUCTIVE,
  ROUTE_SECTION_REST,
  ROUTE_HOME,
  ROUTE_MY_PROFILE,
  ROUTE_SECTION_MY_DNA_PROFILE,
} from 'routes';

import {
  // Nav menu icons
  NavBeProductiveIcon,
  NavEatFreshIcon,
  NavStayActiveIcon,
  NavRestAndRejuvenateIcon,
  NavBeProductiveGrayIcon,
  NavEatFreshGrayIcon,
  NavStayActiveGrayIcon,
  NavRestAndRejuvenateGrayIcon,
  // Subsections
  // -- Be productive
  BeProductiveProfileOrange,
  BeProductiveTipsOrange,
  BeProductiveProfileGray,
  BeProductiveTipsGray,
  // -- Eat fresh
  EatFreshBreakfastGreen,
  EatFreshDinnerGreen,
  EatFreshLunchGreen,
  EatFreshTipsGreen,
  EatFreshProfileGreen,
  EatFreshBreakfastGray,
  EatFreshDinnerGray,
  EatFreshLunchGray,
  EatFreshTipsGray,
  EatFreshProfileGray,
  // -- Rest/Rejuvenate
  RestRejuvenateTipsGray,
  RestRejuvenateTipsPurple,
  RestRejuvenateStretchGray,
  RestRejuvenateStretchPurple,
  // -- Stay active
  StayActiveOfficeRed,
  StayActiveOfficeGray,
  StayActiveOfficeDeepRed,
  StayActiveOfficeDeepGray,
  StayActiveWorkoutGray,
  StayActiveWorkoutRed,
  StayActiveTipsRed,
  StayActiveTipsGray,
  StayActiveProfileRed,
  StayActiveProfileGray,
  // -- Rest
  HomeIconWhite,
  HomeIconGray,
} from 'assets/iconsList';

export const getSideMenuData = () => {
  return {
    routes: [
      {
        id: 0,
        name: 'Home',
        route: ROUTE_HOME,
        color: '#2a343f',
        icon: HomeIconGray,
        iconSelect: HomeIconWhite,
        translationKey: 'dna24.menu.home',
      },
      // {
      //   id: 1,
      //   name: 'My Profile',
      //   translationKey: 'dna24.menu.myDnaProfile',
      //   route: ROUTE_SECTION_MY_DNA_PROFILE,
      //   subsections: [
      //     {
      //       id: 0,
      //       name: 'My Nutrition Profile',
      //       translationKey: 'dna24.menu.nutritionProfile',
      //       route: `${ROUTE_SECTION_MY_DNA_PROFILE}/1`,
      //
      //     },
      //     {
      //       id: 1,
      //       name: 'My Fitness Profile',
      //       translationKey: 'dna24.menu.stayActiveFitnessProfile',
      //       route: `${ROUTE_SECTION_MY_DNA_PROFILE}/2`,
      //
      //     },
      //     {
      //       id: 2,
      //       name: 'My personality profile',
      //       translationKey: 'dna24.menu.beProductivePersonalityProfile',
      //       route: `${ROUTE_SECTION_MY_DNA_PROFILE}/3`,
      //
      //     },
      //     {
      //       id: 3,
      //       name: 'My Skin profile',
      //       translationKey: 'dna24.menu.mySkinProfile',
      //       route: `${ROUTE_SECTION_MY_DNA_PROFILE}/4`,
      //
      //     },
      //     {
      //       id: 4,
      //       name: 'My Allergy profile',
      //       translationKey: 'dna24.menu.myAllergyProfile',
      //       route: `${ROUTE_SECTION_MY_DNA_PROFILE}/5`,
      //
      //     },
      //     {
      //       id: 5,
      //       name: 'My Hair profile',
      //       translationKey: 'dna24.menu.myHairProfile',
      //       route: `${ROUTE_SECTION_MY_DNA_PROFILE}/6`,
      //
      //     },
      //   ],
      // },
      {
        id: 1,
        name: 'Eat Fresh',
        color: '#a8bb30',
        icon: NavEatFreshGrayIcon,
        iconSelect: NavEatFreshIcon,
        translationKey: 'dna24.menu.nutrition',
        route: ROUTE_SECTION_EAT_FRESH,
        subsections: [
          {
            id: 0,
            name: 'My Breakfast',
            icon: EatFreshBreakfastGray,
            iconSelect: EatFreshBreakfastGreen,
            translationKey: 'dna24.menu.nutritionBreakfast',
            route: `${ROUTE_SECTION_EAT_FRESH}/1`,
          },
          {
            id: 1,
            name: 'My Lunch',
            icon: EatFreshLunchGray,
            iconSelect: EatFreshLunchGreen,
            translationKey: 'dna24.menu.nutritionLunch',
            route: `${ROUTE_SECTION_EAT_FRESH}/2`,
          },
          {
            id: 2,
            name: 'My Dinner',
            icon: EatFreshDinnerGray,
            iconSelect: EatFreshDinnerGreen,
            translationKey: 'dna24.menu.nutritionDinner',
            route: `${ROUTE_SECTION_EAT_FRESH}/3`,
          },
          {
            id: 3,
            name: 'My Eating Tips',
            icon: EatFreshTipsGray,
            iconSelect: EatFreshTipsGreen,
            translationKey: 'dna24.menu.nutritionTips',
            route: `${ROUTE_SECTION_EAT_FRESH}/4`,
          },
          {
            id: 4,
            name: 'My Nutrition Profile',
            icon: EatFreshProfileGray,
            iconSelect: EatFreshProfileGreen,
            translationKey: 'dna24.menu.nutritionProfile',
            route: `${ROUTE_SECTION_EAT_FRESH}/5`,
          },
        ],
      },
      {
        id: 2,
        name: 'Stay Active',
        color: '#eb605b',
        icon: NavStayActiveGrayIcon,
        iconSelect: NavStayActiveIcon,
        translationKey: 'dna24.menu.stayActive',
        route: ROUTE_SECTION_STAY_ACTIVE,
        subsections: [
          {
            id: 0,
            name: 'My morning stretch',
            icon: StayActiveOfficeGray,
            iconSelect: StayActiveOfficeRed,
            translationKey: 'dna24.menu.stayActiveMorningStretch',
            route: `${ROUTE_SECTION_STAY_ACTIVE}/1`,
          },
          {
            id: 1,
            name: 'My office stretch',
            icon: StayActiveWorkoutGray,
            iconSelect: StayActiveWorkoutRed,
            translationKey: 'dna24.menu.stayActiveOfficeStretch',
            route: `${ROUTE_SECTION_STAY_ACTIVE}/2`,
          },
          {
            id: 2,
            name: 'My workout exercise',
            icon: StayActiveOfficeDeepGray,
            iconSelect: StayActiveOfficeDeepRed,
            translationKey: 'dna24.menu.stayActiveWorkoutExercise',
            route: `${ROUTE_SECTION_STAY_ACTIVE}/3`,
          },
          {
            id: 3,
            name: 'My exercise tips',
            icon: StayActiveTipsGray,
            iconSelect: StayActiveTipsRed,
            translationKey: 'dna24.menu.stayActiveExerciseTips',
            route: `${ROUTE_SECTION_STAY_ACTIVE}/4`,
          },
          {
            id: 4,
            name: 'My fitness profile',
            icon: StayActiveProfileGray,
            iconSelect: StayActiveProfileRed,
            translationKey: 'dna24.menu.stayActiveFitnessProfile',
            route: `${ROUTE_SECTION_STAY_ACTIVE}/5`,
          },
        ],
      },
      {
        id: 3,
        name: 'Be Productive',
        color: '#f39837',
        icon: NavBeProductiveGrayIcon,
        iconSelect: NavBeProductiveIcon,
        translationKey: 'dna24.menu.beProductive',
        route: ROUTE_SECTION_BE_PRODUCTIVE,
        subsections: [
          // {
          //   id: 0,
          //   name: 'My morning personality',
          //   route: `${ROUTE_SECTION_BE_PRODUCTIVE}/1`,
          //
          // },
          // {
          //   id: 1,
          //   name: 'My social personality',
          //   route: `${ROUTE_SECTION_BE_PRODUCTIVE}/2`,
          //
          // },
          // {
          //   id: 2,
          //   name: 'My work personality',
          //   route: `${ROUTE_SECTION_BE_PRODUCTIVE}/3`,
          //
          // },
          {
            id: 0,
            name: 'My productivity tips',
            icon: BeProductiveTipsGray,
            iconSelect: BeProductiveTipsOrange,
            translationKey: 'dna24.menu.beProductiveTips',
            route: `${ROUTE_SECTION_BE_PRODUCTIVE}/1`,
          },
          {
            id: 1,
            name: 'My personality profile',
            icon: BeProductiveProfileGray,
            iconSelect: BeProductiveProfileOrange,
            translationKey: 'dna24.menu.beProductivePersonalityProfile',
            route: `${ROUTE_SECTION_BE_PRODUCTIVE}/2`,
          },
        ],
      },
      {
        id: 4,
        name: 'Rest & Rejuvenate',
        color: '#8085bd',
        icon: NavRestAndRejuvenateGrayIcon,
        iconSelect: NavRestAndRejuvenateIcon,
        translationKey: 'dna24.menu.restRejuvenate',
        route: ROUTE_SECTION_REST,
        subsections: [
          {
            id: 0,
            name: 'My evening stretch',
            icon: RestRejuvenateStretchGray,
            iconSelect: RestRejuvenateStretchPurple,
            translationKey: 'dna24.menu.restRejuvenateEveningStretch',
            route: `${ROUTE_SECTION_REST}/1`,
          },
          // {
          //   id: 1,
          //   name: 'My sleep profile',
          //   route: `${ROUTE_SECTION_REST}/2`,
          //
          // },
          {
            id: 1,
            name: 'My resting tips',
            icon: RestRejuvenateTipsGray,
            iconSelect: RestRejuvenateTipsPurple,
            translationKey: 'dna24.menu.restRejuvenateTips',
            route: `${ROUTE_SECTION_REST}/2`,
          },
        ],
      },
    ],
  };
};

export const getBottomMenuData = () => {
  return {
    routes: [
      {
        id: 0,
        name: 'My profile',
        translationKey: 'dna24.menu.myProfilePreferences',
        route: `${ROUTE_MY_PROFILE}`,
      },
      {
        id: 1,
        name: 'My Account',
        translationKey: 'dna24.menu.myProfilePreferences',
        route: `${ROUTE_MY_PROFILE}`,
      },
      {
        id: 3,
        name: 'My Account',
        translationKey: 'dna24.menu.myProfilePreferences',
        route: `${ROUTE_MY_PROFILE}`,
      },
    ],
  };
};
